// extracted by mini-css-extract-plugin
export default {"our_team_page_container":"OurTeam_our_team_page_container__YTNh1","our_team_members_container":"OurTeam_our_team_members_container__QgsKJ"};